import { cloneDeep } from 'lodash'

import { Services } from '@sigma-frontend-libs/commons'
import { PUBLIC_FIELDS_USER } from '@sigma-legacy-libs/essentials/lib/constants'

import { PAYMENTS_FILTER, fillDependence, generateServices, permissionPresets } from '@/utils'

import render from './render'

export default function(options = {}) {
  return {
    name: 'List',

    mixins: [
      generateServices({
        name: Services.payments,

        async inputFilter(result) {
          if (!result.Owner) {
            await fillDependence.call(this, result, {
              service: Services.users,
              permissions: permissionPresets.resellerUp,
              pathToId: 'OwnerId',
              pathToObject: 'Owner',
              outputPath: 'Owner',
              picks: PUBLIC_FIELDS_USER
            })
          }

          result.OwnerId = result.OwnerId || result.Owner && result.Owner.id

          return result
        },

        find: {
          defaultFilter: cloneDeep(PAYMENTS_FILTER),
          defaultPagination: { limit: 10 },

          alwaysCreateFromWebSocket: true,
          alwaysUpdateFromWebSocket: true,
          alwaysRemoveFromWebSocket: true
        },

        get: false,
        create: false,
        update: false,
        remove: false
      })
    ],

    data() {
      return {
        showPaymentLogsDialog: false,
        showBillingsDialog: false,

        paymentsBillings: [],

        paymentId: undefined
      }
    },

    computed: {
      canGetPayments() {
        return this.checkPermissions(`advanced.${Services.payments}.get`, permissionPresets.meUp)
      },
      canGetPaymentsAsResellerUp() {
        return this.checkPermissions(`advanced.${Services.payments}.get`, permissionPresets.resellerUp)
      },
      canGetPaymentLogsAsAdmin() {
        return this.checkPermissions(`advanced.${Services.paymentLogs}.get`)
      }
    },

    mounted() {
      if (options.isPage) {
        this.rest[Services.payments].find()
      } else {
        this.restData[Services.payments].find.filter.RecurrentPaymentId = options.RecurrentPaymentId
      }
    },

    render
  }
}
